var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9997 13.7142V7.4748C17.9997 7.22243 18.3045 7.09604 18.4828 7.27449L20.4896 9.2832L23.6894 6.08047C23.7999 5.96984 23.9791 5.96984 24.0896 6.08047L25.9168 7.90928C26.0273 8.01991 26.0273 8.19926 25.9168 8.30989L22.717 11.5126L24.7164 13.5139C24.8947 13.6924 24.7685 13.9975 24.5163 13.9975L18.2827 13.9975C18.1264 13.9975 17.9997 13.8707 17.9997 13.7142Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.2842V24.5236C14 24.776 13.6952 24.9024 13.5169 24.7239L11.51 22.7152L8.31025 25.918C8.19973 26.0286 8.02054 26.0286 7.91001 25.918L6.08289 24.0891C5.97237 23.9785 5.97237 23.7992 6.08289 23.6885L9.28266 20.4858L7.28322 18.4845C7.10493 18.306 7.2312 18.0009 7.48333 18.0009H13.717C13.8733 18.0009 14 18.1277 14 18.2842Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullClose);
export default __webpack_public_path__ + "static/media/full-close.1bee1198bce39c7d68d19edfa5b8272a.svg";
export { ForwardRef as ReactComponent };